import { useEffect, useState } from "react";
import { Form, Col, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import {
  CheckCircleOutlined,
  CloseOutlined,
  UnorderedListOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import useGet from "../../../global/hooks/useGet";
import usePost from "./../../../global/hooks/usePost";
import usePut from "./../../../global/hooks/usePut";
import useDelete from "../../../global/hooks/useDelete";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "./../../../global/components/CommonButton";
// import LicenseOpIcon from "./../../../assets/images/vectors/SideBarIcons/LicenseOpIcon";
import ConfirmModal from "../../../global/components/ConfirmModal";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import PSIcon from "../../../assets/images/vectors/SideBarIcons/PSIcon";
// import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
// import { getModifiedResponse } from "../../../global/utils/responseModifier";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { ProxyInfoColumns } from "../Page/ProxyInfoColumns";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";

export const ProxyForm = ({ type }) => {
  const [nextNo, setNextNo] = useState();
  const [showModal, setShowModal] = useState(false);
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [params, setParams] = useState({
    limit: 10,
    sort_by: "DeviceNo",
    order: "desc",
  }); //
  // console.log(modal);

  // const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const initialPagination = {
    current: parseInt(params.page) || 1,
    pageSize: parseInt(params.limit) || 10,
    total: 0,
  }; //

  const [pagination, setPagination] = useState(initialPagination);

  // to get table data from API server
  const query = new URLSearchParams(params);
  // Remove unwanted keys
  query.delete("pageSize");
  query.delete("total");
  query.delete("current");
  const updatedQuery = query.toString();

  // const siteInfoUrl = id
  //   ? `${process.env.REACT_APP_API_URL}/api/proxy-servers/${id}/?${updatedQuery}`
  //   : null;
  // console.log("siteInfoUrl", siteInfoUrl);
  const url = id
    ? `${process.env.REACT_APP_API_URL}/api/proxy-servers/${id}/?${updatedQuery}`
    : `${process.env.REACT_APP_API_URL}/api/proxy-servers/`;
  const putUrl =
    id && `${process.env.REACT_APP_API_URL}/api/proxy-servers/${id}/`;
  // const listUrl = `${process.env.REACT_APP_API_URL}/api/proxy-servers/`;
  // const postUrl = `${process.env.REACT_APP_API_URL}/api/proxy-servers/`;
  // const putUrl = `${process.env.REACT_APP_API_URL}/api/proxy-servers/${id}/`;
  // const deleteUrl = `${process.env.REACT_APP_API_URL}/api/proxy-servers/${id}/`;
  // const optionUrl = `${process.env.REACT_APP_API_URL}/api/devices/options/`;

  // const {
  //   data: optionsData,

  //   error: optionDataError,
  // } = useGet(optionUrl);

  // const modifiedSiteTypes = getModifiedResponse(optionsData, "sitetype");
  // console.log("modifiedSiteTypes", modifiedSiteTypes);

  const ProxyTypeOptions = [
    { label: "On Premise", value: 0 },
    { label: "Cloud Site", value: 1 },
  ];

  const { data, loading, error, refetch } = useGet(url);
  // console.log({ data });
  const {
    data: listData,
    loading: listDataLoading,
    error: listDataError,
  } = useGet(type === "info" || type === "edit" ? null : url);

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(url);
  const {
    data: putData,
    loading: putLoading,
    error: putError,
    putData: putAction,
  } = usePut(putUrl);
  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    deleteData,
  } = useDelete(url);

  const paginationConfig = {
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: data?.count,
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showTotal: (total, range) => `Total ${total} items ${range[0]}-${range[1]}`,
    onChange: (page, pageSize) => {
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
      });

      const updatedParams = {
        // ...Object.fromEntries([...params.entries()]),
        ...params,
        limit: pageSize,
        page: page,
      };
      setParams(updatedParams);
    },
  }; //

  const onFinish = async (values) => {
    // console.log({ values });
    const modifiedValues = {
      ...values,
      ProxyPort: Number(values.ProxyPort),
    };
    try {
      if (id) {
        // console.log("modifiedValues", modifiedValues);
        await putAction(modifiedValues);
      } else {
        await postAction(modifiedValues);
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
      console.log(error);
    }
  };

  const onReset = () => {
    // form.resetFields();
    navigate(-1);
  };

  const onDeleteConfirm = async () => {
    try {
      await deleteData();
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
  };

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong"
      );
    } else if (!postLoading && !postError && postData) {
      openConfirmNotification("Success");
      setTimeout(() => {
        navigate(-1);
      }, 200);
    }
  }, [postError, postData, postLoading]);

  //toat for update
  useEffect(() => {
    if (putError) {
      openErrorNotification(
        putError?.response?.data?.message || "Something went wrong"
      );
    } else if (!putLoading && !putError && putData) {
      openConfirmNotification("Success");
      refetch();
      setTimeout(() => {
        navigate(-1);
      }, 200);
    }
  }, [putData, putLoading, putError]);

  //   ProxyNo: "",
  // ProxyPort: "",
  // ProxyAddr: "",
  // Address: "",
  // SiteTypeValue: "",
  // console.log("listData", listData);
  // console.log(data, "data");
  useEffect(() => {
    if (Array.isArray(listData?.data) && listData.data.length > 0) {
      const nextOp = Number(listData.data[0].ProxyNo);
      setNextNo(nextOp + 1);
    }
  }, [listDataLoading, listData]);

  // Set default field value
  useEffect(() => {
    if (!id) {
      form.setFieldsValue({
        OptionNo: String(nextNo),
      });
    }
  }, [nextNo]);
  useEffect(() => {
    if (!id || loading) return;
    const getProxyInfoById = () => {
      form.resetFields();
      try {
        if (data?.data?.proxy_data) {
          form.setFieldsValue({
            OptionNo: data?.data?.proxy_data?.ProxyNo
              ? String(data?.data?.proxy_data?.ProxyNo)
              : "",
            ProxyPort: data?.data?.proxy_data?.ProxyPort
              ? String(data?.data?.proxy_data?.ProxyPort)
              : "",
            ProxyAddr: data?.data?.proxy_data?.ProxyAddr
              ? String(data?.data?.proxy_data?.ProxyAddr)
              : "",
            Address: data?.data?.proxy_data?.Address
              ? String(data?.data?.proxy_data?.Address)
              : "",
            ProxyType:
              typeof data?.data?.proxy_data?.ProxyType === "number"
                ? data?.data?.proxy_data?.ProxyType
                : null,
            // SiteTypeName: data?.data?.SiteTypeName
            //   ? String(data?.data?.SiteTypeName)
            //   : "",
            // SiteType: data?.data?.SiteType ? data?.data?.SiteType : "",
          });
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        if (!loading) {
          console.log({ error });
          openErrorNotification("Error fetching data!");
        }
      }
    };

    getProxyInfoById();
  }, [id, data, loading, form, type]);

  // useEffect(() => {
  //   if (!id) {
  //     form.setFieldsValue({
  //       SiteType: 1,
  //     });
  //   }
  // }, [optionsData]);

  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      // refetch();
      navigate("/proxyserver");
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong"
      );
    } else {
      return;
    }
  }, [deletedData, deletedDataError]);

  const breadcrumbItems = [
    {
      label: "Proxy Server",
      href: "/proxyserver",
    },
    {
      label: id ? (type === "info" ? "Information" : "Edit") : "Add",
      href: id
        ? type === "info"
          ? `/proxyserver/info/${id}`
          : `/proxyserver/edit/${id}`
        : "/proxyserver/add",
    },
  ];

  const buttonsData =
    type === "info"
      ? [
          {
            label: "Edit",
            icon: <EditOutlined />,
            onClick: () => {
              navigate(`/proxyserver/edit/${id}`);
            },
          },
          {
            label: "Delete",
            icon: <DeleteOutlined />,
            onClick: () => {
              setShowModal(true);
            },
          },
          {
            label: "List",
            icon: <UnorderedListOutlined />,
            onClick: () => {
              navigate(-1);
            },
          },
        ]
      : [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ];
  return (
    <>
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div>
          <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
            <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
              <CommonButton buttonsData={buttonsData} />
            </CommonBreadcrumb>
          </div>

          <div className="border bg-white rounded-[4px] overflow-hidden">
            <div className="flex items-center bg-gray-200 p-2.5">
              <PSIcon className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                Proxy Server
              </span>
            </div>
            <div className="px-2 pt-1 pb-3">
              <Row gutter={[16, 16]}>
                {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="No"
                        name="SipNo"
                        disabled={type === "info"}
                        type="number"
                        required
                      />
                    </Col> */}
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Proxy Address"
                    name="ProxyAddr"
                    disabled={type === "info"}
                    required
                    loading={loading}
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="IP Address"
                    name="Address"
                    disabled={type === "info"}
                    required
                    loading={loading}
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                      {
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();

                          const ipRegex =
                            /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
                          const domainRegex =
                            /^(?!:\/\/)(?=.{1,253}$)(?!.*\.\.)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;

                          if (ipRegex.test(value) || domainRegex.test(value)) {
                            return Promise.resolve();
                          }

                          return Promise.reject(
                            new Error(
                              "Please enter a valid IP address or domain name"
                            )
                          );
                        },
                      },
                    ]}
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Proxy Port"
                    name="ProxyPort"
                    disabled={type === "info"}
                    required
                    type="number"
                    loading={loading}
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="Proxy Type"
                    name="ProxyType"
                    options={ProxyTypeOptions}
                    placeholder="Please select"
                    disabled={type === "info"}
                    required
                    loading={loading}
                  />
                </Col>
                {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomSelect
                        label="Site Type"
                        name="SiteType"
                        options={modifiedSiteTypes}
                        placeholder="Please select"
                        disabled={type === "info"}
                      />
                    </Col> */}
                {/* {type === "info" && (
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomInput
                          label="Address"
                          name="Address"
                          disabled={type === "info"}
                          required={!id}
                        />
                      </Col>
                    )} */}
              </Row>
            </div>
          </div>
        </div>
      </Form>

      {type === "info" && (
        <div className="mt-6">
          <GlobalTable
            columns={ProxyInfoColumns(setParams, params)}
            dataSource={data?.data?.devices || []}
            pagination={paginationConfig}
            // onRow={onRow}
            resize
          />
        </div>
      )}
      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
      />
    </>
  );
};
